export const PARTNER_FETCH = "PARTNER_FETCH";
/**
 * returns action for partner fetch
 */
export const partnerFetch = data => ({
    type: PARTNER_FETCH,
    payload: {data}
});